import { useState } from "react";

import { ImpactCategory } from "../../../domain/impactCategories";
import useAvailableImpactCategories from "../../../services/useOrganizationFeatures";
import ImpactCategoryToggle from "../../recipes/ImpactCategoryToggle";
import { ProductHighlights } from "./index";

const stories = {
  name: "ProductHighlights",
  children: [
    { name: "Standard", render: () => <ProductHighlightsStory /> },
    {
      name: "No E-Rated Data",
      render: () => <ProductHighlightsStoryNoERatedData />,
    },
    {
      name: "No A-Rated Data",
      render: () => <ProductHighlightsStoryARatedData />,
    },
    { name: "No Data", render: () => <ProductHighlightsStoryNoData /> },
  ],
};

export default stories;

const highImpactProduct = {
  productId: 1,
  productName: "High Impact Product",
  impactIntensity: 50.74180192,
};
const lowImpactProduct = {
  productId: 2,
  productName: "Low Impact Product",
  impactIntensity: 1,
};

function ProductHighlightsStory() {
  const [impactCategory, setImpactCategory] = useState<ImpactCategory>(
    ImpactCategory.GHG
  );
  return (
    <BaseStory
      impactCategory={impactCategory}
      setImpactCategory={setImpactCategory}
    >
      <ProductHighlights
        highImpactProduct={highImpactProduct}
        lowImpactProduct={lowImpactProduct}
        impactCategory={impactCategory}
      />
    </BaseStory>
  );
}

function ProductHighlightsStoryNoERatedData() {
  const [impactCategory, setImpactCategory] = useState<ImpactCategory>(
    ImpactCategory.GHG
  );
  return (
    <BaseStory
      impactCategory={impactCategory}
      setImpactCategory={setImpactCategory}
    >
      <ProductHighlights
        highImpactProduct={null}
        lowImpactProduct={lowImpactProduct}
        impactCategory={impactCategory}
      />
    </BaseStory>
  );
}

function ProductHighlightsStoryARatedData() {
  const [impactCategory, setImpactCategory] = useState<ImpactCategory>(
    ImpactCategory.GHG
  );
  return (
    <BaseStory
      impactCategory={impactCategory}
      setImpactCategory={setImpactCategory}
    >
      <ProductHighlights
        highImpactProduct={highImpactProduct}
        lowImpactProduct={null}
        impactCategory={impactCategory}
      />
    </BaseStory>
  );
}

function ProductHighlightsStoryNoData() {
  const [impactCategory, setImpactCategory] = useState<ImpactCategory>(
    ImpactCategory.GHG
  );
  return (
    <BaseStory
      impactCategory={impactCategory}
      setImpactCategory={setImpactCategory}
    >
      <ProductHighlights
        highImpactProduct={null}
        lowImpactProduct={null}
        impactCategory={impactCategory}
      />
    </BaseStory>
  );
}

function BaseStory({
  children,
  impactCategory,
  setImpactCategory,
}: {
  children: React.ReactNode;
  impactCategory: ImpactCategory;
  setImpactCategory: (category: ImpactCategory) => void;
}) {
  const availableImpactCategories = useAvailableImpactCategories();

  return (
    <div className="p-4">
      <div className="mb-5">
        <ImpactCategoryToggle
          onChange={setImpactCategory}
          options={availableImpactCategories}
          selectedImpactCategory={impactCategory}
        />
      </div>
      <div
        style={{
          width: "457px",
          border: "1px solid #E0E0E0",
          borderRadius: "8px",
        }}
      >
        {children}
      </div>
    </div>
  );
}
